import { render, staticRenderFns } from "./IncompleteVisitsTable.vue?vue&type=template&id=887219b2"
import script from "./IncompleteVisitsTable.vue?vue&type=script&lang=ts"
export * from "./IncompleteVisitsTable.vue?vue&type=script&lang=ts"
import style0 from "./IncompleteVisitsTable.vue?vue&type=style&index=0&id=887219b2&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports